// Copyright (c) 2017 Deere & Company

export default [
    {
        displayName: 'ACCOUNT',
        path: ['responsibleAccount', 'account']
    },
    {
        displayName: 'CITY',
        path: ['responsibleAccount', 'location', 'city']
    },
    {
        displayName: 'STATE',
        path: ['responsibleAccount', 'location', 'state']
    },
    {
        displayName: 'NAME',
        path: ['responsibleAccount', 'name']
    }
];




// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/constants/sort-options.js